import _ from 'lodash';
import validateEmail from '../../helpers/validationHelpers/validateEmail';
import validatePhoneNumberWithCountrySelect from '../../helpers/validationHelpers/validatePhoneNumberWithCountrySelect';

const validateRecipientsInput = (recipients) => {
  if ((recipients || []).length) {
    let isValidated = true;
    _.each(recipients, (recipient) => {
      if (!validateEmail(recipient)) {
        isValidated = false;
      }
    });
    return isValidated;
  }
  return false;
};

const validateForm = (createdFor, fromEmail, emailRecipients, emailSubject,
  customerEmail, customerName, customerPhoneNumber) => {
  let isValid = true;
  const validations = {};

  if (createdFor !== undefined && !createdFor) {
    validations.createdFor = 'Please enter the recipient name.';
    isValid = false;
  } else if (fromEmail !== undefined && !fromEmail) {
    validations.fromEmail = 'Please enter the sender email.';
    isValid = false;
  } else if (fromEmail !== undefined && fromEmail && !validateEmail(fromEmail)) {
    validations.fromEmail = 'Please enter a valid email address.';
    isValid = false;
  } else if (emailRecipients !== undefined && (emailRecipients || []).length === 0) {
    validations.emailRecipients = 'Please enter at least one recipient email.';
    isValid = false;
  } else if (emailRecipients !== undefined && !validateRecipientsInput(emailRecipients)) {
    validations.emailRecipients = 'Please enter a valid email address.';
    isValid = false;
  } else if (emailSubject !== undefined && !emailSubject) {
    validations.emailSubject = 'Please enter an email subject.';
    isValid = false;
  } else if (customerName !== undefined && !customerName) {
    validations.customerName = 'Please enter your name.';
    isValid = false;
  } else if (customerPhoneNumber && !validatePhoneNumberWithCountrySelect(customerPhoneNumber)) {
    validations.customerPhoneNumber = 'Please enter valid phone number.';
    isValid = false;
  } else if (customerEmail !== undefined && !customerEmail) {
    validations.customerEmail = 'Please enter your email.';
    isValid = false;
  } else if (customerEmail !== undefined && customerEmail && !validateEmail(customerEmail)) {
    validations.customerEmail = 'Please enter a valid email address.';
    isValid = false;
  }

  return [isValid, validations];
};
export default validateForm;
